import { faUniversity } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Button from '../../../Button';
import DesktopContainer from '../../../DesktopContainer';
import MobileContainer from '../../../MobileContainer';
import { PTypography } from '../../../Typography';
import { menuDrawerItemProps } from '../../MenuDrawerItems';

const Academy = ({ open }) => (
  <>
    <DesktopContainer>
      <Button
        title="Academy"
        variant="menu"
        leftIcon={<FontAwesomeIcon icon={faUniversity} />}
        buttonProps={{
          ...menuDrawerItemProps.buttonProps,
          ...(open && { selected: 'selected' }),
        }}
      />
    </DesktopContainer>
    <MobileContainer>
      <PTypography
        style={{
          ...menuDrawerItemProps.buttonProps.style,
          paddingBottom: '0px',
        }}
      >
        ACADEMY
      </PTypography>
    </MobileContainer>
  </>
);

export default React.memo(Academy);
